/**
 * common.js starts
 * Created by mac on 20.08.2018.
 */
$(function () {
	var $h = $('.header');
	var sticky = new Waypoint.Sticky({
		element: $('.header-affix')[0],
		handler: function (dir) {
			var $catListTop = $('.product-list-item.top');
			if ($catListTop) {
				var $header = $('.header-affix');
				setTimeout(function () {
					setTopOffset($catListTop, $header);
				}, 300)
			}
		}
	});
	$('.lazyload')
		.lazyload({
			effect: 'fadeIn'
		});
	var $inputMasks = $('.plugin-maskedinput');
	$inputMasks.each(function () {
		var $this = $(this),
			currMask = this.dataset.mask;
		if (currMask) {
			$this.mask(currMask, {
				autoclear: false
			});
		}
	});
	//тройные слайдеры
	var $sl3 = $('.slider-3');
	$sl3.each(function () {
		var $this = $(this);
		if ($this.is('.product-slider')) {
			$this.on('init', function (ev, slider) {
				var photo = slider.$slides[0].querySelector('.product-card__pic');
				arrowsValign(slider, photo);
			});
		}
		$this.slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: slickButtons.prev,
			nextArrow: slickButtons.next,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				}
			}]
		});
	});
	//сворачиваем/разворачиваем фильтр в каталоге
	$(document)
		.on('click', '.filter-heading h3', function (e) {
			var _this = e.target;
			if ($(document)
				.width() < 768) {
				var filterbody = document.querySelector(_this.dataset.target);
				if (filterbody) {
					$(filterbody)
						.toggle('fast');
					_this.classList.toggle('active');
				}
			}
			e.preventDefault();
		});
	$('.plugin-clickable')
		.clickable(); //кликабельные блоки
	/**Анимированные инпуты*/
	var animatedInputs = document.querySelectorAll('.form-row--animated input, .form-row--animated textarea');
	if (animatedInputs) {
		for (var i = 0; i < animatedInputs.length; i++) {
			var input = animatedInputs[i];
			setAnimatedInput(input);
			input.addEventListener('blur', function () {
				setAnimatedInput(this);
			});
		}
	}
	var $galleries = $('.plugin-gallery');
	$galleries.each(function () {
		var $g = $(this);
		$g.magnificPopup({
			type: 'image',
			delegate: '.plugin-gallery-link',
			gallery: {
				enabled: true,
				tPrev: 'Назад',
				tNext: 'Вперед',
				tCounter: '<span class="mfp-counter">%curr% из %total%</span>'
			},
			zoom: {
				enabled: true,
				duration: 300,
				easing: 'ease-in-out',
				opener: function (openerElement) {
					return openerElement;
				}
			}
		});
	});
	$('.mfp-popup')
		.magnificPopup({
			type: 'inline',
			removalDelay: 300
		});
	$('#myTab a')
		.on('click', function (e) {
			$(this)
				.tab('show');
			e.preventDefault();
		});
	var $picsliders = $('.pic-slider');
	$picsliders.each(function () {
		var $this = $(this);
		$this.on('init', function (ev, slider) {
			var photo = slider.$slides[0].querySelector('.pic-slider__pic');
			arrowsValign(slider, photo);
		});
		$this.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: slickButtons.prev,
			nextArrow: slickButtons.next
		});
	});
	//плавная прокрутка
	$('.plugin-slowscroll')
		.slowScroll({
			correct: 120
		});
	//автоизменяющаяся по высоте textarea
	autosize(document.querySelectorAll('.plugin-autosize'));
	//стилизованные файловые инпуты
	Wf.fileStyling(document.querySelectorAll('.custom-file-input'), "Прикрепить файл с резюме");
	//стилизованные селекты
	$('.select-basic')
		.chosen({
			width: '100%',
			disable_search_threshold: 10
		});
	$('.user-form')
		.on('submit', function (e) {
			e.preventDefault();
			var $uf = $(this);
			Wf.submitForm($uf);
		});
	/*Проверка ИНН*/
	var $innInput = $('input[name=UF_INN], input[name=ORG_INN]');
	var sessid = BX.bitrix_sessid();
	$innInput.on('blur', function (e) {
		var innInput = e.target,
			inn = innInput.value,
			log = innInput.parentNode.querySelector('.error-log');
		var result = {
			success: true,
			message: ''
		};
		if (inn.length > 0) {
			$.ajax({
				url: '/ajax/check_inn.php',
				method: "POST",
				data: {
					sessid: sessid,
					INN: inn,
				},
				success: function (res) {
					log.innerHTML = res.message;
					if (res.success === false) innInput.value = '';
				},
				error: function (err) {
					console.log('error', err);
				}
			});
		}
	});
	$('[data-toggle="tooltip"]')
		.tooltip();
});
window.setTopOffset = function ($box, $rel) {
	if ($rel) {
		var relH = $rel[0].offsetHeight;
		$box.css({
			top: relH + 'px'
		});
	}
}
window.slickButtons = {
	prev: '<button class="slick-arrow slick-prev"><span class="k-icon icon-arrow-left"></span></button>',
	next: '<button class="slick-arrow slick-next"><span class="k-icon icon-arrow-right"></span></button>'
};
window.arrowsValign = function (slider, alignTarget) {
	if (slider.$nextArrow && slider.$nextArrow.is(':visible')) {
		var $prev = slider.$prevArrow,
			$next = slider.$nextArrow,
			targetH = $(alignTarget)
			.outerHeight(),
			arrowH = $prev.outerHeight();
		var offset = targetH / 2 - arrowH / 2;
		css = {
			top: offset + 'px'
		};
		$prev.css(css);
		$next.css(css);
	} else {
		return false;
	}
}
window.setAnimatedInput = function (input) {
	if (input.value === '') input.classList.remove('not-empty');
	else input.classList.add('not-empty');
}
/**getTpl - возвращает html-код шаблона с заданным id
 * @param {string} id - id шаблона
 * */
window.getTpl = function (id) {
	return document.getElementById(id)
		.innerHTML;
}
/* common.js ends */
